import { render, staticRenderFns } from "./CategoryTile.vue?vue&type=template&id=0747aad1&scoped=true&"
import script from "./CategoryTile.vue?vue&type=script&lang=js&"
export * from "./CategoryTile.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTile.vue?vue&type=style&index=0&id=0747aad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747aad1",
  null
  
)

export default component.exports